// Hook que carga el catálogo completo de ejercicios — globales (creados
// por dev via migration / seed, `created_by_kine_id IS NULL`) + custom
// del kine logueado (Sprint 3+, `created_by_kine_id = kine.id`). Hoy
// hay 1 ejercicio en DB (`rot_externa_banda`, global).
//
// Usado por BibliotecaEjercicios.tsx (display del catálogo) y, en el
// bloque siguiente (Rutinas), por el form de prescripción para popular
// el selector de ejercicios. La shape `Ejercicio` está pensada como
// contrato compartido entre ambos consumers — cuando se agregue
// filtrado por calibrado (Sprint 3), se hará via `schema_path !== null`
// sin cambiar la shape.

import { useEffect, useState } from "react";
import { supabase } from "../client";

export type ViewAngle =
  | "frontal"
  | "lateral_left"
  | "lateral_right"
  | "flexible";

export interface Ejercicio {
  id: string;
  nombre: string;
  descripcion: string | null;
  region_anatomica: string | null;
  view_angle: ViewAngle;
  setup_hint: string | null;
  schema_path: string;
  imagen_url: string | null;
  /** `null` = catálogo global (compartido entre todos los kines).
   *  UUID = custom de ese kine. Sprint 3 abre creación custom. */
  created_by_kine_id: string | null;
}

interface State {
  data: Ejercicio[] | null;
  error: string | null;
  loading: boolean;
}

export function useEjercicios(): State {
  const [state, setState] = useState<State>({
    data: null,
    error: null,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from("ejercicios")
        .select(
          "id, nombre, descripcion, region_anatomica, view_angle, setup_hint, schema_path, imagen_url, created_by_kine_id",
        )
        .order("region_anatomica", { ascending: true, nullsFirst: false })
        .order("nombre", { ascending: true })
        .returns<Ejercicio[]>();

      if (cancelled) return;

      if (error) {
        console.warn("[useEjercicios] error cargando catálogo", error);
        setState({ data: null, error: error.message, loading: false });
        return;
      }

      setState({ data: data ?? [], error: null, loading: false });
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
